import { route } from 'nextjs-routes';
import { Box, Center, Container, Flex, Grid, GridItem, GridProps, Image, Link, Text, VStack, Icon, HStack } from '@chakra-ui/react';
import IconSvg from 'ui/shared/IconSvg';
import React from 'react';
const linkGroup = [
  {
    title: 'Company',
    link: [
      { content: 'Whitepaper', url: 'https://pionechain.com/whitepaper.pdf' },
      { content: 'Tokenomics', url: 'https://pionechain.com/company/tokenomics/' },
      { content: 'Roadmap', url: 'https://pionechain.com/company/roadmap/' },
      { content: 'News', url: 'https://pionechain.com/news/' },
      { content: 'About Us', url: 'https://pionechain.com/ecosystem' },
      // { content: 'Brand Assets', url: '#' },
      { content: 'Contact Us', url: 'https://pionechain.com/contact' },
      // { content: 'Careers', url: '#' },
      { content: 'Terms & Privacy', url: 'https://pionechain.com/privacy-policy' },
      // { content: 'Bug Bounty', url: '#' },
    ],
  },
  {
    title: 'Products & Services',
    link: [
      { content: 'Pione Wallet', url: 'https://pionewallet.com/' },
      { content: 'Pione Care', url: 'https://pionecare.com/' },
      { content: 'Pione Dream', url: 'https://pionedream.com/' },
      { content: 'Pione House', url: 'https://pionehouse.com/' },
      { content: 'Pione Mart', url: 'https://pionemart.com/' },
      { content: 'Pione Swap', url: 'https://pioneswap.com/' },
      { content: 'ExPione', url: 'https://expione.com/' },
    ],
  },
  {
    title: 'Ecosystem',
    link: [
      { content: 'Pione Farm', url: 'https://pionefarm.com/' },
      { content: 'Pione AI', url: 'https://pioneai.com/' },
      { content: 'Pione Zero', url: 'https://zeroscan.org/' },
      { content: 'Pione Security', url: 'https://pionesecurity.com/' },
      { content: 'Pione Solution', url: 'https://pionesolution.com/' },
      { content: 'Pione Super App', url: 'https://pionesuperapp.com/' },
      { content: 'Pione Game', url: 'https://pionegame.com/' },
    ],
  },
];

const LIST_ICON = [
  {
    name: 'social/twitter_filled' as const,
    size: '36px',
    sizeMobile: '30px',
    url: 'https://x.com/pione_chain',
  },
  {
    name: 'social/telegram_filled' as const,
    size: '36px',
    sizeMobile: '30px',
    url: 'https://t.me/pionechain',
  },
  {
    name: 'social/facebook_filled' as const,
    size: '36px',
    sizeMobile: '30px',
    url: 'https://www.facebook.com/pionechain',
  },
  {
    name: 'social/youtube' as const,
    size: '30px',
    sizeMobile: '25px',
    url: 'https://www.youtube.com/@pione_chain',
  },
];

function scrollToTop() {
  var section = document.getElementById('top-navbar-01');
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
}

const containerProps: GridProps = {
  h: { base: '100%', lg: '280px' },
  templateColumns: { base: 'repeat(2, 1fr)', lg: 'repeat(5, 1fr)' },
  gap: { base: 2, lg: 6 },
  px: { base: 0, lg: 8 },
  pt: { base: 6, lg: 10 },
  pb: { base: 1, lg: 5 }
};

const Footer = () => {
  return (
    <Box as="footer" pt={{ base: 4, lg: 6 }}>
      {/* Icon */}
      <Box px={{ base: 8, lg: 24 }} borderTop={'5px solid #E2E8F0'} bg="#fff"
      boxShadow={'0px 4px 8px rgba(0, 0, 0, 0.2)'}
      borderRadius={{ base: 20, lg: '20px'}}
      margin={'auto'}
      marginBottom={'20px'}
      width={'95%'}
      >
        <Container maxW={'container.xl'} px={ 0 }>
          <Grid {...containerProps}>
            <GridItem colSpan={2} h="100%" mb={{ base: 5, lg: 0 }}>
              <Flex
                h={'100%'}
                w={'100%'}
                flexDirection={'column'}
                justify={'center'}
                alignItems={'start'}
                rowGap={{ base: 3, lg: 5 }}
                mb={{base: 5, lg: 0}}
              >
                <Box
                  as="a"
                  href={ route({ pathname: '/' }) }
                  width="auto"
                  height="auto"
                  display="inline-flex"
                  overflow="visible"
                  flexGrow={0}
                  aria-label="Link to main page"
                >
                  <Image
                    src={'/static/network_logo.png'}
                    alt="icon-logo-pionebosscan"
                    w='auto'
                    h='auto'
                    maxW={{ base: '200px', lg: '275px' }}
                    maxH={{ base: '45px', lg: '65px' }}
                    objectFit="contain"
                  />
                </Box>

                <Text fontSize="sm" color={'#000'}>
                  Blockchain layer 1 - Unlocking the power of your Real-World Assets (RWA) and explore 
                  practical applications of blockchain and AI in security tokens, real estate,...
                </Text>
                <HStack spacing={{base: 1, lg: 2}}>
                  {LIST_ICON.map((icon, _index) => (
                    <Link key={'footer-item-'+_index} href={ icon.url } target='_blank' display="flex" alignItems="center" h="40px" color={"#000"}
                    _hover={{
                      '&': {
                        color: "#5b8fff"
                      }
                    }}>
                      <Center minW={ 6 }>
                        <IconSvg boxSize={{base: icon.size}} name={ icon.name }/>
                      </Center>
                    </Link>
                  ))}
                </HStack>
              </Flex>
            </GridItem>
            {linkGroup.map((itemlink, index) => (
              <GridItem
                key={"GridItem"+index}
                colSpan={{base: index === 2 ? 2 : 1, lg: 1}}
                h="100%"
                pl={{ base: 0, lg: 3 }}
                mb={{ base: 5, lg: 0 }}
              >
                <VStack spacing={1} alignItems="start">
                  <Text fontWeight="600" mb="1" fontSize="md" color={'#000'}>
                    {itemlink.title}
                  </Text>
                  <Box as={'ul'} listStyleType={'none'}>
                    {itemlink.link.map((subLink, _subIndex) => (
                      <Box as="li" key={_subIndex}>
                        <Link
                          color={'#000'}
                          key={_subIndex}
                          href={subLink.url}
                          display="flex"
                          alignItems="center"
                          h="26px"
                          variant="secondary"
                          // target="_blank"
                          _hover={{
                            '&': {
                              color: '#5b8fff',
                            },
                          }}
                          fontSize="xs"
                          flexWrap={{ base: 'nowrap', lg: 'wrap' }}
                        >
                          {subLink.content}
                        </Link>
                      </Box>
                    ))}
                  </Box>
                </VStack>
              </GridItem>
            ))}
          </Grid>
        </Container>

        <Flex borderTop={'1px solid #E2E8F0'} justifyContent={"space-between"} alignItems={"center"} width={'80%'} margin={'auto'} >
          <Text fontSize={{ base: 'xs', lg: 'sm' }} fontWeight={500} py={{ base: 2, lg: 3 }} color={'#000'}>
            Pione BOS Scan © {new Date().getFullYear()}
          </Text>
       </Flex>
      </Box>
    </Box>
  );
};

export default Footer;
